import PortalPrograms from '@classes/Programs'
import Collapse from '@components/Collapse'
import EmptyState from '@components/EmptyState'
import { StoreProps } from '@interfaces/StoreState'
import MediaPanel from '@layouts/MyMedia/MediaPanel'
import { REG_STATUS } from '@utils/constants'
import React from 'react'
import { useSelector } from 'react-redux'

const MyMediaLayout: React.FC = () => {
  const portalProg = useSelector(
    ({ userProfile }: StoreProps) =>
      new PortalPrograms(userProfile?.info?.StudentProfile?.StudentProfileInfo?.ProgramStudentWrappers ?? [])
  )
  const programs = portalProg.programs
  const EmptyRecordings = () => <EmptyState heading="No recordings found." img="/images/lost.svg" />

  if (!programs || !programs.length) {
    return <EmptyRecordings />
  }

  // Filter out F2F programs - they don't have recordings
  const nonF2fStarPrograms = portalProg.nonF2fStarProgramsOnly()

  if (!nonF2fStarPrograms || !nonF2fStarPrograms.length) {
    return <EmptyRecordings />
  }

  const lookUpProg = portalProg?.ValidSchedulingPrograms
    ? portalProg?.ValidSchedulingPrograms
    : portalProg?.CompletedPrograms
  const activeIds = [lookUpProg?.[0]?.ProgramStudentInfo?.ProgramId]
  const StatusPriority = [REG_STATUS.COMPLETED, REG_STATUS.IN_PROGRESS, REG_STATUS.ACTIVE, REG_STATUS.PENDING_START]

  /**
   * Heads up! sort fn is a mutable operation, so we need to clone the array first
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/sort#sort_returns_the_reference_to_the_same_array
   */
  let sortedProg = nonF2fStarPrograms.slice().sort((a, b) => {
    return (
      StatusPriority.indexOf(b?.ProgramStudentInfo?.Status || '') -
      StatusPriority.indexOf(a?.ProgramStudentInfo?.Status || '')
    )
  })

  return (
    <Collapse activeIds={activeIds}>
      {sortedProg.map(({ ProgramStudentInfo }) => (
        <MediaPanel
          programId={ProgramStudentInfo?.ProgramId}
          key={ProgramStudentInfo?.ProgramId}
          active={activeIds.includes(ProgramStudentInfo?.ProgramId)}
        />
      ))}
    </Collapse>
  )
}

export default MyMediaLayout